import { createSelector } from "reselect";

const getCommentFromState = (state: IAppState) => state.comment;

export const getCommentData = createSelector(
  getCommentFromState,
  (comment): IAsyncEntityState<TThread> => comment
);
